<template>
  <div class="badges-wrapper">
    <div v-for="(badge, key) in allBadges" :key="key" class="badge">
      <img v-if="badgesAcquired.includes(badge[0])" v-tooltip="badge[1].description.organisation" width="100" :src="badge[1].img" :alt="badge[1].title" />
      <img v-else width="100" :src="badge[1]['img-grey']" :alt="badge[1].title" v-tooltip="badge[1].description.organisation"/>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/style/variables.scss";

.badges-wrapper {
  flex-grow: 1;
  flex-basis: 0;

  display: flex;
  justify-content: center;
  align-content: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 16px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    padding-left: 4px;
    width: 3px;
    border-radius: 24px;
    background-color: var(--light-grey-color);
  }

  &::-webkit-scrollbar-thumb {
    background: $primary-color;
    padding: 4px;
    width: 3px;
    border-radius: 24px;
  }

  .badge {
    display: flex;
    gap: 24px;

    img {
      height: 100%;
    }

    .text {
      flex: 8;
      display: flex;
      flex-direction: column;
      gap: 8px;

      .title {
        font-size: 18px;
        font-weight: 600;
      }

      .description {
        font-size: 16px;
      }
    }
  }
}
</style>

<script setup>
import { computed } from "vue";
import i18n from '@/i18n';
import { useI18n } from 'vue-i18n';

const { locale } = useI18n();

const props = defineProps({
  talent: {
    type: Object,
    required: true,
  },
});

const badgesAcquired = computed(() => {
  if (!props?.talent?.results?.badges) return [];
  return Object.entries(props.talent.results.badges)
    .filter(([badgeName, isUnlocked]) => isUnlocked)
    .map(([key, _]) => key)
});

const allBadges = computed(() => {
  const localeData = i18n.global.messages.value[locale.value];
  const badgeLocales = Object.entries(localeData.badges);
  return badgeLocales;
});
</script>
